import { Box } from '@mui/material';

import Typography from '@/components/Typography';
import { Status } from '@/features/DataHub/pages/PastExports/components/Status';

export const ExportItemHeader = ({
  status,
  name
}: {
  status: 'finished' | 'failed' | 'ongoing';
  name: string;
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        gap: 2,
        alignItems: 'center'
      }}
    >
      <Typography
        size={18}
        sx={{ fontWeight: 700 }}
      >
        {name}
      </Typography>
      <Box>
        <Status status={status} />
      </Box>
    </Box>
  );
};
